// extracted by mini-css-extract-plugin
export var Grey = "SideScroll-module--Grey--a027e";
export var LightEmerald = "SideScroll-module--Light-Emerald--869ab";
export var White = "SideScroll-module--White--05527";
export var backgroundImage = "SideScroll-module--background-image--85997";
export var bleed = "SideScroll-module--bleed--acb5e";
export var card = "SideScroll-module--card--01a2a";
export var cards = "SideScroll-module--cards--d985a";
export var content = "SideScroll-module--content--b8f67";
export var copy = "SideScroll-module--copy--e2d90";
export var cta = "SideScroll-module--cta--81735";
export var logo = "SideScroll-module--logo--1554b";
export var manualScroll = "SideScroll-module--manual-scroll--668de";
export var overlappingBleed = "SideScroll-module--overlapping-bleed--2cf65";
export var sideScroll = "SideScroll-module--side-scroll--168fa";
export var snippet = "SideScroll-module--snippet--1bcd2";
export var snippets = "SideScroll-module--snippets--c1418";
export var spacer = "SideScroll-module--spacer--55e31";
export var superheading = "SideScroll-module--superheading--e9497";
export var title = "SideScroll-module--title--dec04";